import './cityButtons.css';
import { useState } from 'react';
import axios from 'axios';
import { DateRange, DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import DoctorImage from '../DoctorPictures/DoctorPictures';
import UserInfoModal from '../UserInfoModal/UserInfoModal';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';

Modal.setAppElement('#root');

const CityButtons = () => {
  const [freeTimes, setFreeTimes] = useState([]);
  const [showFreeTimes, setShowFreeTimes] = useState(false);
  const [showAdditionalButtons, setShowAdditionalButtons] = useState(false);
  const [filterValue, setFilterValue] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [translatedValue, setTranslatedValue] = useState("");

  const { t } = useTranslation(); // Initialize the useTranslation hook

  const url2 = "babeweb.trafore.com";
  const ssl2 = "https";

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000), // Adding 7 days to the current date
      key: 'selection',
    },
  ]);
  

// Function to authenticate and fetch data for a specific city
const handleCityButtonClick = async (selectedCity) => {
  try {
    // Authenticate
    const responseAuth = await axios.post(
      `${ssl2}://${url2}:3001/authenticate`,
      {}
    );
    
    // Assuming the token is returned in the 'token' property
    const authToken = responseAuth.data.token;
    console.log("auth toookkeni", authToken);

    // Fetch data for the selected city
    const response = await axios.post(
      `${ssl2}://${url2}:3001/${selectedCity}`,
      { authToken },
      {}
    );
    console.log("auth toookkeni22", authToken);
    // Set the freeTimes state with the response data
    setFreeTimes(response.data.response.data);
  } catch (error) {
    console.error('Error:', error);
  }
};


  const openModal = (appointment) => {
    setSelectedAppointment(appointment);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedAppointment(null);
    setIsModalOpen(false);
  };

  console.log("freetimes state ", freeTimes);
  
  const handleButtonClickCalendar = () => {
    const monthVertical = document.querySelector('.rdrMonthsVertical');
    const monthYearWrapper = document.querySelector('.rdrMonthAndYearWrapper');
    const dateDisplayWrapper = document.querySelector('.rdrDateDisplayWrapper');

    // Toggle the 'active' class on each element
    monthVertical.classList.toggle('active');
    monthYearWrapper.classList.toggle('active');
    dateDisplayWrapper.classList.toggle('active');
  };

  const renderFreeTimesList = (filterValue) => {
    // Get the current date
    const currentDate = new Date();
  
    const compareDatesAndTimes = (a, b) => {
      const dateA = new Date(a.fieldData.DATETIME);
      const dateB = new Date(b.fieldData.DATETIME);
  
      // Compare dates first
      if (dateA > dateB) return 1;
      if (dateA < dateB) return -1;
  
      // If dates are equal, compare times
      const timeA = new Date(`1970-01-01 ${a.fieldData.TIME}`);
      const timeB = new Date(`1970-01-01 ${b.fieldData.TIME}`);
  
      if (timeA > timeB) return 1;
      if (timeA < timeB) return -1;
  
      return 0; // Dates and times are equal
    };
  
    // Filter free times to show only those within the selected date range
    const filteredFreeTimes = freeTimes.filter((appointment) => {
      const appointmentDate = new Date(appointment.fieldData.DATETIME);
      // Set hours, minutes, seconds, and milliseconds to 0 for comparison
      appointmentDate.setHours(0, 0, 0, 0);
  
      // Set hours, minutes, seconds, and milliseconds to 0 for comparison
      const startDateWithoutTime = new Date(dateRange[0].startDate);
      startDateWithoutTime.setHours(0, 0, 0, 0);
  
      // Set hours, minutes, seconds, and milliseconds to 23:59:59:999 for comparison
      const endDateWithoutTime = new Date(dateRange[0].endDate);
      endDateWithoutTime.setHours(23, 59, 59, 999);
  
      const isWithinDateRange =
        appointmentDate >= startDateWithoutTime &&
        appointmentDate <= endDateWithoutTime;
  
      return isWithinDateRange && appointment.fieldData.NAME === filterValue;
    });
  
    // Sort the filteredFreeTimes array using the compareDatesAndTimes function
    filteredFreeTimes.sort(compareDatesAndTimes);
  
    const groupedAppointments = {};
  
    // Group appointments by Doctor Name
    filteredFreeTimes.forEach((appointment) => {
      const doctorName = appointment.fieldData.DOCTORNAME;
      if (!groupedAppointments[doctorName]) {
        groupedAppointments[doctorName] = [];
      }
      groupedAppointments[doctorName].push(appointment);
    });

    const formatTimeWithoutSeconds = (timeString) => {
      // Extract hours and minutes from the time string
      const [hours, minutes] = timeString.split(':').map(Number);

      // Check if the extracted values are valid
      if (!isNaN(hours) && !isNaN(minutes)) {
        // Construct a new Date object with a common reference date
        const time = new Date(2000, 0, 1, hours, minutes);

        // Format the time string using toLocaleTimeString
        const formattedTime = time.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
        return formattedTime;
      }

      // Return the original time string if parsing fails
      return timeString;
    };
    
    const formatDate = (dateTimeString) => {
      const dateTime = new Date(dateTimeString);
      const day = dateTime.getDate().toString().padStart(2, '0');
      const month = (dateTime.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-indexed
      const year = dateTime.getFullYear();
      const formattedDate = `${day}.${month}.${year}`;
      return formattedDate;
    };
    
    
  
    return (
      <div className='main-container'>
        <div className='datepicker-container'>
        <h2>{t('vapaatajat')}</h2>
        <h3>{translatedValue}</h3>
        <div>
          <div className="date-picker-nav">
            <button onClick={handlePrevWeek} className='dateRangeButtons button-top-left'>&lt;</button>
            <DateRangePicker ranges={dateRange} onChange={handleDateRangeChange} 
            showMonthArrow={false}
            >
            </DateRangePicker>
            <button onClick={handleNextWeek} className='dateRangeButtons'>&gt;</button>
          </div>
          <button
          id='calendar-button'
          className="calendar-button"
          onClick={handleButtonClickCalendar}
        >
          &#128197;
        </button>
          {/* Add the rest of your component logic here */}
        </div>
        </div>
        <div className="free-appointments-container">
          {Object.entries(groupedAppointments).map(([doctorName, appointments]) => (
            <div key={doctorName} className="doctor-appointments">
              <DoctorImage doctorName={doctorName}></DoctorImage>
              <h3>{doctorName}</h3>
              <ul className="appointment-list">
              {appointments.map((appointment) => (
                <button key={appointment.recordId} className="appointment-button" onClick={() => openModal(appointment)}>
                  <li className="appointment-item">
                    <div className="appointment-info">
                      <div>
                        <strong></strong> {formatDate(appointment.fieldData.DATETIME)}{' '}
                        {formatTimeWithoutSeconds(appointment.fieldData.TIME)}
                      </div>
                    </div>
                  </li>
                </button>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <UserInfoModal
        translatedValue={translatedValue}
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        appointmentDetails={
          selectedAppointment
            ? {
                date: formatDate(selectedAppointment.fieldData.DATETIME),
                time: formatTimeWithoutSeconds(selectedAppointment.fieldData.TIME),
                doctorname: selectedAppointment.fieldData.DOCTORNAME,
                treatment: selectedAppointment.fieldData.NAME,
                id: selectedAppointment.fieldData.DOCTOR,
              }
            : null
        }
      />
      </div>
    );
  };
  
  

  //button click handler
  const handleButtonClick = (filterValue, translate) => {
    setShowFreeTimes(true);
    setShowAdditionalButtons(false);
    setFilterValue(filterValue);
    setTranslatedValue(translate);
  };

  // Function for treatment buttons to appear on screen
  const renderAdditionalButtons = () => {
    if (showAdditionalButtons) {
      return (
        <>
          <button className="treatment-button" onClick={() => handleButtonClick('Netti-Ensikäynti', t('ensikäynti'))}>
            {t('ensikäynti')}
          </button>
          <button className="treatment-button" onClick={() => handleButtonClick("Netti-Hedelmällisyyskatsastus")}>
            Hedelmällisyyskatsastus
          </button>
          <button className="treatment-button" onClick={() => handleButtonClick("Netti-Sperma-analyysi")}>
            Sperma-analyysi
          </button>
          <button className="treatment-button" onClick={() => handleButtonClick("Netti-Gynekologi")}>
            Gynekologi
          </button>
          <button className="treatment-button" onClick={() => handleButtonClick("Netti-Hoidon suunnittelu")}>
            Hoidon suunnittelu
          </button>
          <button className="treatment-button" onClick={() => handleButtonClick("Netti-Varhaisraskauden ultra")}>
            Varhaisraskauden ultra
          </button>
          <button className="treatment-button" onClick={() => handleButtonClick("Netti-Munanjohtimien aukiolotutkimus")}>
            Munanjohtimien aukiolotutkimus
          </button>
          <button className="treatment-button" onClick={() => handleButtonClick("Netti-Hoitajan antama hedelmällisyysneuvonta")}>
            Hoitajan antama hedelmällisyysneuvonta
          </button>
        </>
      );
    }
    return null; // Render nothing if showAdditionalButtons is false
  };
  
  const [isActive, setIsActive] = useState(false);

  const handleShowAdditionalButtons = () => {
    handleCityButtonClick("findall")
    setIsActive((prevIsActive) => !prevIsActive);
    setShowAdditionalButtons(!showAdditionalButtons);
    setShowFreeTimes(false)
  };

  //
  // Date range picker functions
  //

  const handlePrevWeek = () => {
    let newStartDate = new Date(dateRange[0].startDate);
    newStartDate.setDate(newStartDate.getDate() - 7);
  
    // Ensure the start date is not in the past
    const currentDate = new Date();
    if (newStartDate < currentDate) {
      newStartDate = currentDate;
    }
  
    const newEndDate = new Date(newStartDate);
    newEndDate.setDate(newEndDate.getDate() + 6);
    
    setDateRange([{ startDate: newStartDate, endDate: newEndDate, key: 'selection' }]);
  };

  const handleNextWeek = () => {
    const newStartDate = new Date(dateRange[0].startDate);
    newStartDate.setDate(newStartDate.getDate() + 7);
    const newEndDate = new Date(newStartDate);
    newEndDate.setDate(newEndDate.getDate() + 6);
    setDateRange([{ startDate: newStartDate, endDate: newEndDate, key: 'selection' }]);
  };

  const handleDateRangeChange = (ranges) => {
    const { startDate, endDate } = ranges.selection;
  
    // Get the current date
    const currentDate = new Date();
  
    // If the start date is in the past, set it to the current date
    if (startDate < currentDate) {
      ranges.selection.startDate = currentDate;
    }
  
    // If the end date is in the past, set it to the current date
    if (endDate < currentDate) {
      ranges.selection.endDate = currentDate;
    }
  
    // Update the date range
    setDateRange([ranges.selection]);
  };

  return (
    <>
    <div className="city-buttons-container">
    <h1>{t('ajanvaraus')}</h1>
      <h2>{t('valitse_toimipiste')}</h2>
      <button className={`city-button ${isActive ? 'active' : ''}`} onClick={handleShowAdditionalButtons}>
        {t('helsinki')}
      </button>
      <div className="treatment-buttons-container">
      {showAdditionalButtons && renderAdditionalButtons()}
      {showFreeTimes && renderFreeTimesList(filterValue)}
    </div>
    </div>
    </>
  );
};

export default CityButtons;